module.exports = "#version 300 es\r\n\r\n// A vertex shader used by all post-process shaders to simply pass UV data\r\n// to the fragment shader, and to position the vertices of the screen-space quad \r\n\r\nprecision highp float;\r\n\r\nin vec4 vs_Pos;\r\nin vec4 vs_Nor;\r\nin vec4 vs_Col;\r\nin vec2 vs_UV;\r\n\r\nout vec2 fs_UV;\r\n\r\nvoid main() {\r\n\tfs_UV = vs_UV;\r\n\tgl_Position = vs_Pos;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/screenspace-vert.glsl
// module id = 37
// module chunks = 0